// components/FilePreviewDialog.jsx
import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { MdOutlineZoomIn } from "react-icons/md";

const FilePreviewDialog = ({ file }) => {
  const [textPreview, setTextPreview] = useState("");

  useEffect(() => {
    if (!file) return;

    // Se manca preview e il file è immagine o PDF, la creiamo
    const ext = file.name.split(".").pop()?.toLowerCase();
    if (
      !file.preview &&
      ["jpg", "jpeg", "png", "gif", "webp", "pdf"].includes(ext)
    ) {
      file.preview = URL.createObjectURL(file);
    }

    // Se è file di testo, leggiamone il contenuto
    if (["txt", "csv"].includes(ext)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setTextPreview(e.target.result);
      };
      reader.readAsText(file);
    }
  }, [file]);

  const renderPreview = () => {
    const ext = file.name.split(".").pop()?.toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) {
      return (
        <img
          src={file.preview}
          alt="preview"
          className="w-full h-full object-contain"
        />
      );
    } else if (ext === "pdf") {
      return (
        <iframe
          src={file.preview}
          title="PDF Preview"
          className="w-full h-full border-none"
        />
      );
    } else if (["txt", "csv"].includes(ext)) {
      return (
        <pre className="whitespace-pre-wrap text-sm p-2">{textPreview}</pre>
      );
    } else {
      return (
        <p className="text-center">
          Anteprima non disponibile per questo formato.
        </p>
      );
    }
  };

  return (
    <Dialog>
      <DialogTrigger onClick={(e) => e.stopPropagation()}>
        <MdOutlineZoomIn className="text-2xl cursor-pointer text-white hover:text-gray-300 transition-colors" />
      </DialogTrigger>
      <DialogContent className="max-w-4xl h-[80vh] flex flex-col">
        <h2 className="font-bold text-lg mb-2">{file.name}</h2>
        <div className="flex-1 overflow-auto">{renderPreview()}</div>
      </DialogContent>
    </Dialog>
  );
};

export default FilePreviewDialog;
